import { render, staticRenderFns } from "./ProductSearchDialog.vue?vue&type=template&id=5f4f9dd0&scoped=true&lang=pug&"
import script from "./ProductSearchDialog.vue?vue&type=script&lang=ts&"
export * from "./ProductSearchDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSearchDialog.vue?vue&type=style&index=0&id=5f4f9dd0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4f9dd0",
  null
  
)

export default component.exports